import React from 'react';
import ReactMarkdown from 'react-markdown';
import './Privacy.css';

const Privacy = () => {
  const [privacy, setPrivacy] = React.useState('');

  React.useEffect(() => {
    const privacyContent = `
# Politica de Confidențialitate și GDPR - Antifurt QR

## 1. Introducere
Aplicația **Antifurt QR** respectă confidențialitatea utilizatorilor și se angajează să protejeze datele personale conform **Regulamentului General privind Protecția Datelor (GDPR)** și altor legi aplicabile privind confidențialitatea.

Prin utilizarea aplicației, sunteți de acord cu această Politică de Confidențialitate.

## 2. Ce date colectăm?

Utilizăm datele doar pentru funcționarea și îmbunătățirea serviciului nostru. Colectăm următoarele informații:

### **2.1. Date furnizate de utilizator**
- Numele complet (opțional)
- Numărul de telefon (opțional)
- Descrierea obiectelor înregistrate
- Adresa de e-mail (pentru conturi create)

### **2.2. Date colectate automat**
- **Date despre scanările codurilor QR:**
  - IP-ul dispozitivului care scanează
  - User agent-ul browserului/dispozitivului
  - Data și ora scanării
- **Date despre utilizarea aplicației:**
  - Tipul dispozitivului și sistemul de operare
  - Informații despre erori și performanță

## 3. Cum utilizăm datele colectate?
Datele sunt utilizate exclusiv pentru:
- Crearea și gestionarea codurilor QR ale utilizatorilor
- Notificarea utilizatorului în cazul scanării unui cod QR
- Îmbunătățirea aplicației și securității acesteia
- Detectarea și prevenirea utilizării abuzive sau frauduloase

## 4. Cu cine partajăm datele?
Nu vindem și nu închiriem datele utilizatorilor către terți. Putem partaja informațiile doar în următoarele cazuri:
- **Autorități legale**, dacă suntem obligați prin lege
- **Furnizori de servicii**, care ne ajută la stocarea și procesarea datelor (ex.: servicii cloud securizate)

## 5. Drepturile utilizatorilor conform GDPR
Aveți dreptul să:
- Accesați datele dvs. stocate în aplicație
- Modificați sau ștergeți informațiile asociate contului dvs.
- Solicitați ștergerea definitivă a contului și a datelor aferente
- Contestați prelucrarea datelor și să solicitați restricționarea procesării
- Exportați datele într-un format utilizabil

Pentru exercitarea acestor drepturi, ne puteți contacta la **contact@antifurt.app**.

## 6. Securitatea datelor
Luăm măsuri tehnice și organizatorice pentru protejarea datelor împotriva accesului neautorizat, pierderii sau modificării acestora.

## 7. Perioada de stocare a datelor
Datele sunt păstrate doar atât timp cât este necesar pentru furnizarea serviciului sau conform obligațiilor legale.

## 8. Modificări ale politicii de confidențialitate
Ne rezervăm dreptul de a modifica această politică. Orice modificare va fi anunțată în aplicație.

## 9. Contact
Pentru întrebări sau solicitări legate de confidențialitate, ne puteți contacta la **contact@antifurt.app**.

---
Prin utilizarea **Antifurt QR**, confirmați că ați citit și acceptat această Politică de Confidențialitate.`;

    setPrivacy(privacyContent);
  }, []);

  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <ReactMarkdown>{privacy}</ReactMarkdown>
      </div>
    </div>
  );
};

export default Privacy;